import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-packaging-Stroke',
  standalone: true,
  templateUrl: '../../assets/packaging/Stroke.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamPackagingStrokeIcon {}
